import React from 'react';
import SystemsViewScaffold, { ComingSoonBody } from './SystemsViewScaffold';

/**
 * Phase 3 — Takaisinkytkentäkartta (Causal Loop Diagram).
 * AI proposes signed edges (+/-) and reinforcing/balancing loops from impact-path
 * nodes + lens items (single RAG search, callAiStructured + SCHEMAS); facilitator
 * curates. Productises what workshops/vipupisteanalyysi.md does by hand today.
 */
export default function CausalLoopScreen() {
  return (
    <SystemsViewScaffold viewKey="causalLoops">
      <ComingSoonBody>
        <p>
          Syy-seurauskehät tuotteena: tekoäly ehdottaa merkityt yhteydet (+/−) sekä
          vahvistavat (R) ja tasapainottavat (B) silmukat vaikutuspoluista ja
          linssien havainnoista. Fasilitaattori kuratoi. Tämä tuotteistaa sen, mitä
          <code> workshops/vipupisteanalyysi.md</code> tekee nyt käsin.
        </p>
      </ComingSoonBody>
    </SystemsViewScaffold>
  );
}
